export const hasAnyRole = (userRoles: string[], requiredRoles: string[]): boolean => {
	return requiredRoles.some(role => userRoles.includes(role));
};

export const canAccess = (userRoles: string[], requiredRoles: string[]): boolean => {
	return requiredRoles.length === 0 || hasAnyRole(userRoles, requiredRoles);
};
